import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { CommandMenu } from "@/components/CommandMenu";
import { UserMenu } from "@/components/UserMenu";
import { FearGreedBadge } from "@/components/FearGreedBadge";
import { useLocation } from "react-router-dom";
import { 
  Home, 
  TrendingUp, 
  Calculator, 
  Activity, 
  Bell, 
  Settings,
  BarChart3
} from "lucide-react";

const routeTitles: Record<string, { title: string; icon: React.ComponentType<{ className?: string }> }> = {
  "/app": { title: "Overview", icon: Home },
  "/app/overview": { title: "Overview", icon: Home },
  "/app/markets": { title: "Markets", icon: TrendingUp },
  
  "/app/valuation": { title: "Valuation", icon: Calculator },
  "/app/alpha-onchain": { title: "Alpha On-Chain", icon: Activity },
  "/app/alerts": { title: "Alerts", icon: Bell },
  "/app/macro": { title: "Macro", icon: BarChart3 },
  "/app/macro-btc": { title: "Liquidez Macro", icon: BarChart3 },
  "/app/market-monitor": { title: "Market Intelligence", icon: Activity },
  "/app/settings": { title: "Settings", icon: Settings },
  "/chart": { title: "Chart", icon: TrendingUp },
};

export const AppHeader = () => {
  const location = useLocation();
  const currentRoute = routeTitles[location.pathname] || { title: "Crystos AI", icon: Home };
  const IconComponent = currentRoute.icon;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center px-3 md:px-6">
        <div className="flex items-center gap-2 md:gap-4">
          <SidebarTrigger />
          <div className="flex items-center gap-2">
            <IconComponent className="h-4 w-4 md:h-5 md:w-5 text-primary" />
            <h1 className="text-base md:text-lg font-semibold text-foreground truncate max-w-[140px] md:max-w-none">
              {currentRoute.title}
            </h1>
          </div>
        </div>
        
        <div className="flex-1 mx-2 md:mx-6">
          <CommandMenu />
        </div>
        
        <div className="flex items-center gap-2 md:gap-3">
          <div className="hidden md:flex">
            <FearGreedBadge />
          </div>
          <UserMenu />
        </div>
      </div>
    </header>
  );
};